// AGC: Wagmi configuration for Origami Battles
// AGC: Integrates Coinbase Wallet (with Smart Wallet), MetaMask, and RainbowKit
// AGC: Optimized for Base blockchain and Hardhat local development

import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { hardhat, baseSepolia, base, supportedChains } from './networks'
import { http } from 'wagmi'

/**
 * AGC: Wagmi configuration using RainbowKit's getDefaultConfig
 * AGC: This automatically includes MetaMask, Coinbase, WalletConnect, etc.
 * AGC: Using Reown (WalletConnect) project ID with origami.local domain whitelisted
 */
const baseSepoliaRpc =
  import.meta.env.VITE_BASE_SEPOLIA_RPC_URL ||
  import.meta.env.VITE_BASE_RPC_URL ||
  'https://sepolia.base.org'

const baseMainnetRpc =
  import.meta.env.VITE_BASE_MAINNET_RPC_URL ||
  'https://mainnet.base.org'

export const desktopConfig = getDefaultConfig({
  appName: 'Origami Battles',
  projectId: '6d0eaa5614ab4d62a37e712a7de9addf', // AGC: Reown Project ID (from dashboard settings)
  chains: supportedChains,
  transports: {
    [baseSepolia.id]: http(baseSepoliaRpc),
    [base.id]: http(baseMainnetRpc),
    [hardhat.id]: http('http://127.0.0.1:8545'),
  },
  ssr: false, // AGC: Not using server-side rendering
  // AGC: Explicitly enable Coinbase Wallet
  walletConnectParameters: {
    metadata: {
      name: 'Origami Battles',
      description: 'Origami Battles - On-Chain Battle Game',
      url: typeof window !== 'undefined' ? window.location.origin : 'https://origami-battles.com',
      icons: typeof window !== 'undefined' ? [`${window.location.origin}/favicon.ico`] : []
    }
  }
})

/**
 * AGC: RainbowKit theme configuration
 * AGC: Matches Origami Battles visual style
 */
export const rainbowKitTheme = {
  accentColor: '#7b3ff2', // AGC: Purple accent matching Origami theme
  accentColorForeground: 'white',
  borderRadius: 'medium',
  fontStack: 'system',
  overlayBlur: 'small',
} as const
